export enum EVENTS {
	RESTART = 'restart',
	PLAYER_POSE = 'player-pose',
	INSTRUCTOR_POSE = 'instructor-pose',
}
